const config = {
    "host":"/API" // endpoint for api calls ,could be URL (https://www.api.com:9000 , or local path /YourApiPath
}

export default config;